module.exports = __webpack_public_path__ + "static/img/item7.95d4876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item7.png
// module id = jqlv
// module chunks = 1